/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";

// Register the store
store("create-brand-showcaser", {
  actions: {
    toggle1: () => {
      const context = getContext();
      context.isOpen1 = true;
      context.isOpen2 = false;
      context.isOpen3 = false;
	  context.isOpen4 = false;
	  context.isOpen5 = false;
	  context.isOpen6 = false;
	  context.isOpen7 = false;
    context.isOpen8 = false;
    },
    toggle2: () => {
      const context = getContext();
      context.isOpen2 = true;
      context.isOpen1 = false;
      context.isOpen3 = false;
      context.isOpen4 = false;
      context.isOpen5 = false;
      context.isOpen6 = false;
      context.isOpen7 = false;
      context.isOpen8 = false;
    },
    toggle3: () => {
      const context = getContext();
      context.isOpen3 = true;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen4 = false;
      context.isOpen5 = false;
      context.isOpen6 = false;
      context.isOpen7 = false;
      context.isOpen8 = false;
    },
    toggle4: () => {
      const context = getContext();
      context.isOpen4 = true;
      context.isOpen5 = false;
      context.isOpen6 = false;
      context.isOpen7 = false;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen3 = false;
      context.isOpen8 = false;
    },
    toggle5: () => {
      const context = getContext();
      context.isOpen5 = true;
      context.isOpen4 = false;
      context.isOpen6 = false;
      context.isOpen7 = false;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen3 = false;
      context.isOpen8 = false;
    },
    toggle6: () => {
      const context = getContext();
      context.isOpen6 = true;
      context.isOpen5 = false;
      context.isOpen4 = false;
      context.isOpen7 = false;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen3 = false;
      context.isOpen8 = false;
    },
    toggle7: () => {
      const context = getContext();
      context.isOpen7 = true;
      context.isOpen6 = false;
      context.isOpen5 = false;
      context.isOpen4 = false;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen3 = false;
      context.isOpen8 = false;
    },
    toggle8: () => {
      const context = getContext();
      context.isOpen8 = true;
      context.isOpen7 = false;
      context.isOpen6 = false;
      context.isOpen5 = false;
      context.isOpen4 = false;
      context.isOpen1 = false;
      context.isOpen2 = false;
      context.isOpen3 = false;
    }
  },
});
